import React, { useEffect, useMemo, useState } from "react";
import styles from "./DispatcherCompletedOrder.module.scss"
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import { Button, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { connect, useDispatch } from "react-redux";
import {
  getAllOrders,
  getDeliveredOrders,
  getPendingOrdersResponse,
  getProductById,
} from "../../store/actions";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "Order ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "Cart Bundle ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "Customer Name",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: 5,
  //   label: "Status",
  //   minWidth: 170,
  //   align: "center",
  // },
];

const CompletedOrder = ({ orders = [], customers = [] }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // dispatch(getDeliveredOrders());
    dispatch(getDeliveredOrders());
  }, []);

  const handleNavigate = (item = {}) => {
    dispatch(getPendingOrdersResponse(item));
    dispatch(getProductById({ id: item?.productId }));
    navigate("/orderdetails");
  };

  const deliveredOrders = useMemo(
    () => (orders || []).filter((item) => item?.status === 3),
    [orders]
  );

  const ordersWithCustomers = useMemo(() => {
    return deliveredOrders.map((order) => {
      const customerObj = getObjectFromArrayOfObjects(
        customers,
        "id",
        order?.customerId
      );

      const fallbackName = [customerObj?.firstName, customerObj?.lastName]
        .filter(Boolean)
        .join(" ");

      const customerName =
        customerObj?.fullName ||
        customerObj?.name ||
        fallbackName ||
        "NA";

      return {
        ...order,
        customerName,
      };
    });
  }, [deliveredOrders, customers]);

  const filteredOrders = useMemo(() => {
    if (!searchQuery.trim()) {
      return ordersWithCustomers;
    }

    const loweredQuery = searchQuery.trim().toLowerCase();

    return ordersWithCustomers.filter((order) => {
      const customerName = order?.customerName || "";
      const orderCode = order?.orderCode || "";

      return (
        customerName.toLowerCase().includes(loweredQuery) 
      );
    });
  }, [ordersWithCustomers, searchQuery]);


  
  const getStructuredRows = (data = []) => {
    return data.map((item, idx) => ({
      id: item.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleNavigate(item)}
        >
          {item.orderCode || "NA"}
        </Button>,
        item.cartBundleId,
        item?.customerName ||
          getObjectFromArrayOfObjects(customers, "id", item?.customerId)
            ?.fullName ||
          "NA",
        // item.customerName,
        // <Button
        //   variant="contained"
        //   className={styles.ovalButton3}
        //   disableRipple
        //   disableElevation
        // >
        //   Delivered
        // </Button>,
      ],
    }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search by customer name"
              onSearch={setSearchQuery}
            /> */}

          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(filteredOrders)}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    orders: state?.orders?.orders,
    customers: state?.customer?.customers
  };
};

export default connect(mapStateToProps, null)(CompletedOrder);
